<template>
  <v-snackbar
    v-model="mensaje.ver"
    location="top center"
    :timeout="mensaje.conTimeOut ? 4000 : -1"
    class="mi-snackbar"
    :color="mensaje.color"
    elevation="24"
    rounded="pill"
  >
    <div class="text-subtitle-1 text-center w-100">
      {{ mensaje.contenido }}
    </div>

    <template #actions>
      <v-btn
        icon
        variant="text"
        @click="mensaje.ver = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name:'Mensaje',
  props:{
    mensaje:Object
  }
}
</script>
<style scoped>
.mi-snackbar {
  max-width: 600px;
  margin: 0 auto;
}
</style>